import { AnalyticsService } from "@gtmhub/core/analytics";
import { providerUpgradeFactory } from "@webapp/core/provider-upgrade/factories/provider-upgrade.factory";

// TODO: https://gtmhub.atlassian.net/browse/GVS-12389
export const AnalyticsServiceProvider = {
  provide: AnalyticsService,
  useFactory: providerUpgradeFactory("AnalyticsService"),
  deps: ["$injector"],
};
